import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';

const ITEMS = [
  { label: 'Scheduling', icon: 'ph-calendar-plus', path: '/openslot/scheduling' },
  { label: 'Availability', icon: 'ph-clock', path: '/openslot/availability' },
  { label: 'Time off', icon: 'ph-airplane-tilt', path: '/openslot/time-off' },
  { label: 'Bookings', icon: 'ph-calendar-check', path: '/openslot/bookings' },
] as const;

/**
 * Shared secondary (left) sidebar for the Open Slot section — the same nav on every page.
 * `pathname` decides the active item (Scheduling stays active on the event-type form route too).
 */
export function openSlotSidebar(navigate: NavigateFunction, pathname: string) {
  return function OpenSlotSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar title="Scheduling" mobileExpanded={api.secondarySidebarExpanded} onClose={api.closeSecondarySidebar}>
        <SecondarySidebarSection title="Scheduling" flush>
          <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
            {ITEMS.map((it) => {
              const active =
                it.path === '/openslot/scheduling'
                  ? pathname.startsWith('/openslot/scheduling')
                  : pathname === it.path;
              return (
                <li className="nav-item" key={it.path}>
                  <a
                    href={it.path}
                    className={`nav-link ${active ? 'active' : ''}`.trim()}
                    onClick={(e) => {
                      e.preventDefault();
                      go(it.path);
                    }}
                  >
                    <i className={`${it.icon} me-3`} />
                    {it.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </SecondarySidebarSection>
      </SecondarySidebar>
    );
  };
}
